export default __webpack_public_path__ + "static/me-b638d6615c8dc2a5b6b763d0b56bf0e5.jpeg";